import React from 'react';
import ArrowLeftOutlineIcon from './arrow-left-outline';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ArrowBackIcon(props) {
  return ___EmotionJSX(ArrowLeftOutlineIcon, props);
}